/**
 * Resolves headshot URL by adding S3 prefix if needed
 * @param headshot - The headshot value to resolve
 * @returns The resolved headshot URL
 */
export function resolveHeadshotUrl(headshot: string | File | undefined | null): string {
  // Guard against File objects being passed (indicates a bug in the calling code)
  if (headshot instanceof File) {
    console.error('resolveHeadshotUrl received a File object instead of a string URL. This indicates the file was not uploaded before calling this function.');
    return '';
  }

  if (!headshot) {
    return '';
  }

  // Check if it's already a valid URL
  if (isValidUrl(headshot)) {
    return headshot;
  }

  // Add S3 prefix for non-URL values (no trailing slash to avoid double slash)
  const S3_PREFIX = 'https://afy-staging-book-covers.s3.amazonaws.com/user-images';
  return `${S3_PREFIX}/${headshot}`;
}

/**
 * Checks if a string is a valid URL
 * @param str - String to check
 * @returns True if string is a valid URL
 */
function isValidUrl(str: string): boolean {
  try {
    const url = new URL(str);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}